module.exports = __webpack_public_path__ + "img/TREASURY.3cecea53.svg";